// 持久客户端 ID（第二通道）。服务端下发两个 cookie：
//   zxcid   —— httpOnly，前端读不到，是服务端信任的主通道；
//   zxcid_m —— 非 httpOnly 镜像，本模块读它、写入 localStorage，并在每个请求以 X-Client-Id 头回注。
// 作用：即便浏览器清了 cookie（或 Safari ITP 截断 cookie 寿命），localStorage 里的 id 仍能在下次请求
// 把服务端的 httpOnly cookie「自愈」回同一个值——甩号成本不因清 cookie 而降低。纯客户端指纹靠猜，
// 这个 id 是服务端亲手贴的标签，可靠一个量级。
const KEY = 'zxdata.clientId';

function readMirrorCookie(): string | null {
  try {
    const m = document.cookie.match(/(?:^|;\s*)zxcid_m=([a-f0-9-]{32,36})(?:;|$)/i);
    return m ? m[1] : null;
  } catch {
    return null;
  }
}

function readLocal(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function writeLocal(v: string): void {
  try {
    localStorage.setItem(KEY, v);
  } catch {
    /* ignore（隐私模式/禁用存储时降级，仅靠 cookie 通道） */
  }
}

// 同步取值供请求拦截器注入。镜像 cookie（服务端最新值）优先，回填 localStorage；否则用 localStorage。
export function getClientId(): string | null {
  const fromCookie = readMirrorCookie();
  if (fromCookie) {
    if (readLocal() !== fromCookie) writeLocal(fromCookie);
    return fromCookie;
  }
  return readLocal();
}
